import { prop } from 'ramda';
import { valueHandler } from '../csomjsom/csomJsomShared';

const getUrlValue = (value) => {
    const { Url, Description } = value || {};

    return {
        url: Url,
        description: Description,
    };
};

const getLookupId = prop('LookupId');

const getField = prop;

const csomValueHandler = valueHandler(getField, getLookupId, getUrlValue);

export default csomValueHandler;
